import {connect} from 'react-redux';
import Component from '../components/ContentWrapper';
import {signOut} from '../actions';
import {mapNavigationToProps} from '../selectors';

export default connect(mapNavigationToProps, {handleSignOut: signOut})(Component);